<script>
import commonservice from "../shared/common.service";
import axios from "axios";
export default {
  name: "baseview",
  mixins: [commonservice],
  data() {
    return {
      grid: {
        options: {},
        total: 0,
        body: [],
        headers: [],
        search: null,
        loading: false,
        loadoninit: true,
        filter: null,
        footerProps: {
          "items-per-page-options": [10, 20, 30, 40],
        },
        itemsperpage: 20,
      },
      loading: false,
      vModel: {},
      initVModel: {},
      dialog: false,
      url: null,
      isEdit: false,
    };
  },
  created() {
    setTimeout(() => {
      this.initVModel = Object.assign({}, this.vModel);
    }, 300);
  },
  watch: {
    "grid.options": {
      handler() {
        this.loadGrid();
      },
      deep: true,
    },
    "grid.search": {
      handler() {
        this.loadGrid();
      },
    },
  },
  computed: {
    gridUrl() {
      var param = {
        // sortdesc: this.grid.options.sortDesc.length > 0 ? this.grid.options.sortDesc[0] : "",
        // sortBy: this.grid.options.sortBy.length > 0 ? this.grid.options.sortBy[0] : "",
        sortdesc: this.grid.options.sortDesc,
        sortBy: this.grid.options.sortBy,
        page: this.grid.options.page,
        pagesize: this.grid.options.itemsPerPage  
      };
      if (this.grid.search) param.search = this.grid.search;
      let url = this.url + "?" + this.convertToQueryString(param);
      if (this.grid.filter != null)
        url += "&" + this.convertToQueryString(this.grid.filter);
      //url = url.replace(/&+$/, "");
      return url;
    },
  },
  methods: {
    convertToQueryString: function (obj) {
      return commonservice.convertToQueryString(obj);
    },
    filtergrid() {
      this.grid.loadoninit = true;
      this.loadGrid();
    },
    loadGrid() {
      if (!this.grid.loadoninit) {
        return;
      }
      if (this.grid.headers.length == 0) return;
      this.grid.loading = true;
      axios
        .get(this.gridUrl)
        .then((response) => {
          this.grid.loading = false;
          this.grid.body = response.data.rows;
          this.grid.total = response.data.count;
        })
        .catch(() => {
          this.grid.loading = false;
        });
    },
    closedialog() {
      if (!this.dialog) return;
      this.dialog = false;
      this.resetForm();
    },
    showdialog(clear) {
      this.dialog = true;
      if (clear) {
        setTimeout(() => {
          this.vModel = Object.assign({}, this.initVModel);
          this.$nextTick(() => {
            this.$refs.form.reset();
            document.getElementsByTagName("form")[0].elements[0].focus();
          });
        }, 300);
      }
    },
    saveandreset(reset) {
      this.save(true);
    },
    save(reset) {
      if (this.loading) return;
      this.loading = true;
      if (this.beforeSave()) {
        var axiosHandler = null;
        if (this.isEdit) {
          axiosHandler = axios.patch(this.url, this.vModel);
        } else {
          axiosHandler = axios.post(this.url, this.vModel);
        }
        axiosHandler.then(
          () => {
            let msg = this.$t("language.successfulsave", {
              entity: this.$t("language." + this.$store.getters.pagetitle),
            });
            this.$store.dispatch("showSuccessMessage", msg);
            if (reset) this.resetForm();
            else this.closedialog();
            this.loadGrid();
            this.afterSave();
            this.loading = false;
          },
          () => {
            this.loading = false;
          }
        );
      }
    },
    newItem() {
      this.isEdit = false;
      this.showdialog(true);
    },
    editItem(id) {
      if (this.loading) return;
      this.loading = true;
      axios.get(this.url + "/" + id).then(
        (response) => {
          this.isEdit = true;
          let data = this.processEditData(response.data);
          this.vModel = data;
          this.onEditDataRecieved();
          this.showdialog(false);
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
    },
    deleteItem(id) {
      this.$confirm(this.$t("language.deleteconfirm")).then((res) => {
        if (res) {
          if (this.loading) return;
          this.loading = true;
          axios.delete(this.url + "/" + id).then(
            (response) => {
              this.loadGrid();
              let msg = this.$t("language.successfuldelete", {
                entity: this.$t("language." + this.$store.getters.pagetitle),
              });
              this.$store.dispatch("showSuccessMessage", msg);
              this.loading = false;
            },
            () => {
              this.loading = false;
            }
          );
        }
      });
    },
    afterSave() {},
    beforeSave() {
      return true;
    },
    onEditDataRecieved() {},
    processEditData(data) {
      return data;
    },
    getResetValues(){
      return this.initVModel;
    },
    resetForm() {
      this.vModel = Object.assign({}, this.getResetValues());

      setTimeout(() => {
        this.$nextTick(() => {
          this.$refs.form.reset();
        });
      }, 300);
    },
    getDefaultDate: function (engDate) {
      return commonservice.getDefaultDate(engDate);
    }
  },
};
</script>
